export const typeWola = 'wola'
export const typeWolaGF = 'wolagf'
